import { getOrderMutationErrorMessage } from "@/features/order/errors";
import { useReplaceOrderItem } from "@/features/order/hooks";
import type { EnrichedOrderItem } from "@/features/order/types";
import { ReplacementComposer } from "./ReplacementComposer";

export function OrderItemReplacementModal({
  item,
  expectedVersion,
  onClose,
  onSuccess,
}: {
  item: EnrichedOrderItem;
  expectedVersion: number;
  onClose: () => void;
  onSuccess?: (result: string) => void;
}) {
  const replaceItem = useReplaceOrderItem();
  const receivedQuantity = item.received_quantity;

  return (
    <ReplacementComposer
      open
      original={{
        productId: item.product_id,
        productName: item.product_name,
        supplierId: item.supplier_id,
        supplierName: item.supplier_name,
        unitType: item.unit_type,
        requestedQuantity: item.quantity,
        receivedQuantity,
        pendingQuantity: Math.max(item.quantity - receivedQuantity, 0),
        realPrice: item.real_price,
        finalPrice: item.final_price,
      }}
      pending={replaceItem.isPending}
      onClose={onClose}
      onReplace={async ({ replacement, ...handling }) => {
        await replaceItem.mutateAsync({
          orderId: item.order_id,
          itemId: item.id,
          payload: {
            ...replacement,
            ...handling,
            expected_version: expectedVersion,
          },
        });
      }}
      onSuccess={(_mode, result) => onSuccess?.(result)}
      getErrorMessage={getOrderMutationErrorMessage}
    />
  );
}
